<script lang="ts">
  import MelPlayer from "./MelPlayer.svelte";
  import { onMount } from "svelte";
  import { Howl, Howler } from "howler";
  import vhCheck from "vh-check";
  // import {title, description, collection, video_hd, video_mobile, sound} from './videos/Circleverse.json';
  import * as objkt from "./videos/Ixomo_01.json";
  // import * as objkt from './videos/Circleverse.json';

  let loaded = false;
  let audio;
  let audio_id;
  let video;

  let audio_file = objkt.sound ? objkt.sound : objkt.video_mobile;
  let key;
  let keyCode;
  let max_volume = 1;
  let blur = false;
  // let video_progress = 0;

  let video_time = 0;
  let video_duration = 0;

  let audio_volume = 0;

  let audio_time = 0;
  let audio_duration = 0;
  let audio_rate = 1;

  let debug = false;
  let flip = false;
  let color_invert = false;

  $: video_progress = (video_time / video_duration) * 100;
  $: audio_progress = (audio_time / audio_duration) * 100;

  onMount(() => {
    vhCheck();

    audio = new Howl({
      src: [`assets/${audio_file}`],
      loop: true,
      volume: 0.0,
      preload: true,
      onvolume: (e) => {
        audio_volume = audio.volume();
      },
      onplay: function () {
              audio_duration = audio.duration();
             requestAnimationFrame(step.bind(this));
         }.bind(this)
      ,
      onrate: (e) => {
       audio_rate = Math.round(audio.rate()*100)/100;
       video.playbackRate = audio_rate;
      }

    });
  });
  function step(){
    audio_time = audio.seek() || 0;
    if (audio.playing()) {
     requestAnimationFrame(step);
   }
  }
  function handleClick(event) {
    if (!audio) {
      return;
    }
    if (audio.volume() == max_volume) {
      // console.log(`Fading out ${audio.volume()}`);
      audio.fade(max_volume, 0, 500);
    } else if (audio.volume() == 0) {
      if (!audio_id) {
        audio_id = audio.play();
      }
      // console.log(`Fading in ${audio.volume()}`);
      audio.fade(0, max_volume, 500);
    }

    // console.log("toggle audio");
  }
  function clamp(num, min, max) {
  return num <= min
    ? min
    : num >= max
      ? max
      : num
}

  function handleKeydown(event) {
    key = event.key;
    keyCode = event.keyCode;

    // D
    if (keyCode == 68) {
      debug = !debug;
    }

    // SPACE
    else if (keyCode == 32) {
      if (!video.paused){
        handleClick(undefined);
      }
    }

    // I
    else if (keyCode == 73){
      color_invert = !color_invert
    }
    // J
    else if (keyCode == 74){
      decrease_rate();
    }
    // K
    else if (keyCode == 75){
      audio.rate(1)
    }
    // L
    else if (keyCode == 76){
      increase_rate();
    }

    // B
    else if (keyCode == 66){
      blur = !blur;
    }

    // F
    else if (keyCode == 70){
      flip = !flip;
    }

    // +
    else if (keyCode == 107 || keyCode == 187){
      max_volume = clamp(max_volume + 0.1,0,1);
      audio.fade(audio.volume(), max_volume, 500);
    }
    // -
    else if (keyCode == 189 || keyCode == 109){
      max_volume = clamp(max_volume - 0.1,0,1);
      audio.fade(audio.volume(), max_volume, 500);
    }
  }

  function increase_rate(){
    audio.rate(clamp(audio.rate() + 0.05,0.01,4))
  }
  function decrease_rate(){
    audio.rate(clamp(audio.rate() - 0.05,0.01,4))
  }

</script>

<svelte:head>
  <title
    >{`${objkt.collection ? objkt.collection + " - " : ""}${
      objkt.title
    }`}</title
  >
</svelte:head>

<svelte:window on:keydown={handleKeydown} />
<main>
  {#if debug && false}
    <div style="text-align: center" class="keyboard">
      {#if key}
        <kbd>{key === " " ? "Space" : key}</kbd>
        <p>{keyCode}</p>
      {:else}
        <p>Focus this window and press any key</p>
      {/if}
      <div>
        <p>audio rate {audio_rate} | other infos ...</p>
        <button on:click={()=> flip = !flip}> {flip ? "UNFLIP": "FLIP"} </button>
        <button on:click={()=> {video.currentTime = 0;audio.seek(0)}}> SEEK(0) </button>
        <button on:click={()=> {audio.seek(video.currentTime)}}> RESYNC AUDIO </button>
        <button on:click={decrease_rate}> - RATE </button>
        <button on:click={increase_rate}> + RATE </button>
        <button on:click={()=> color_invert = !color_invert}> INVERT </button>

        <h3>video progress</h3>
        <div class="progress_container">
          <div class="progress" style="width:{video_progress}%"></div>
        </div>
        <h3>audio progress</h3>
        <div class="progress_container">
          <div class="progress" style="width:{audio_progress}%"></div>
        </div>

        <h3>audio volume</h3>
        <div class="progress_container">
          <div class="progress" style="width:{audio_volume*100}%"></div>
        </div>
      </div>
    </div>
  {/if}
  <MelPlayer
    src={`assets/${objkt.video_hd}`}
    src_mobile={`assets/${objkt.video_mobile}`}
    on:loaded={(ev) => {
      audio.seek(0);
      // console.log(ev);
    }}
    on:restarted={(ev) => {
      audio.play(audio_id);
    }}
    on:click={handleClick}
    flip = {flip}
    blur = {blur}
    sync={objkt.sound ? false : true}
    title={objkt.title}
    subtitle={objkt.collection}
    description={objkt.description}
    bind:duration = {video_duration}
    bind:currentTime = {video_time}
    bind:video = {video}
    bind:color_invert = {color_invert}
  />
</main>

<style>
  :global(html),
  :global(body) {
    background-color: rgb(10, 10, 10);
    padding: 0;
    margin: 0;
  }
  .progress_container{
    background-color: rgb(10, 10, 10);
    border-radius: 0.4em;
    margin-left: 25%;
    /* border: solid 0.2em #ff0101;
    border-radius: .4em; */
    width:50%;
  }
  .progress{
    background-color: #fff;
    border-radius: 0.2em;
    height:24px;
  }

  :global(body) {
    width: 100vw;
    height: calc(100vh - var(--vh-offset, 0px));
    overflow: hidden;
  }
  .keyboard {
    position: fixed;
    width: 100vw;
    height: 100vh;
    padding-top: 2em;
    color: #eee;
  }
  kbd {
    background-color: #eee;
    border-radius: 4px;
    font-size: 3em;
    padding: 0.2em 0.5em;
    border-top: 5px solid rgba(255, 255, 255, 0.5);
    border-left: 5px solid rgba(255, 255, 255, 0.5);
    border-right: 5px solid rgba(0, 0, 0, 0.2);
    border-bottom: 5px solid rgba(0, 0, 0, 0.2);
    color: #555;
  }
  main {
    text-align: center;
    width: 100vw;
    height: calc(100vh - var(--vh-offset, 0px));
    overflow: hidden;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
